module.exports = __webpack_public_path__ + "img/s.2cac122a.png";